/**
 * DEV / STAGE on every screen (step 96): a thin line along the top of the window and a small tab in its
 * middle, in dev's or staging's own colour — nothing on production (`environmentMark`). Touches nothing:
 * `pointer-events: none`, so the header under it works as before.
 */
import { environmentMark } from '@/lib/environment';
import { useT } from '@/i18n';
import './EnvironmentRibbon.css';

export function EnvironmentRibbon() {
  const tr = useT();
  const mark = environmentMark();
  if (!mark) return null;
  return (
    <div className="env-ribbon" data-env={mark} role="note" aria-label={tr('Test version')}>
      <span className="env-ribbon-tab">{mark}</span>
    </div>
  );
}
